// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__vPw2k","active":"sidebar_active__zn6nE"};